import React__default from 'react';

const root = "_root_v76ot_1";
const content = "_content_v76ot_33";
const styles = {
	root: root,
	content: content
};

const Divider = ({ height, width = "full", children, "aria-hidden": ariaHidden = void 0 }) => {
  return React__default.createElement("div", { role: "separator", "aria-hidden": ariaHidden, className: styles.root, style: { "--zds-internal-divider-height": `${height}px` }, "data-width": width }, children && React__default.createElement("span", { className: styles.content }, children));
};

export { Divider };
//# sourceMappingURL=Divider.es.js.map
